export function searchForEstablishmentById(establishments, id) {
  const establishment =
    establishments.filter(establishment => establishment.id == id);
  if (establishment){
    return establishment[0];
  }
  return null;
}



/** WEBPACK FOOTER **
 ** ./src/selectors/searchForEstablishment.js
 **/